import { useGetHeaders } from "@hooks/useGetHeaders";
import { CommonCMS } from "@lib/constants/contentful";

export const useEccoClubMicrocopies = () =>
    useGetHeaders({
        source: CommonCMS.shared,
        microcopiesWithTitles: {
            createAccount: CommonCMS.button.createAccount,
            logIn: CommonCMS.button.logIn,
            joinTheClub: CommonCMS.joinTheClubTitle,
            seeBenefits: CommonCMS.button.seeMoreBenefits,
            myAccount: CommonCMS.myAccount,
        },
    });
